
export const EMAIL_CONFIG = {
  SERVICE_ID: 'service_90zd53m',
  TEMPLATE_ID: 'template_tatrjzu', 
  PUBLIC_KEY: 'J7dauj5qlZuFBPAt5' 

};